<template>
    <div class="parentMessage">
        <div v-if="isData==0" class="noContent">
              <NoContent></NoContent>
        </div>
        <div class="inner" v-else>
            <header>
                家长问卷信息调查
            </header>           
            <div >
                <div class="main_box">
                    <Title title="家长基本信息"></Title>
                    <div class="main">
                        <div class="line_flex">
                            <p class='flex2'>
                                <span class="name">母亲职业：</span>
                                <span class="detail">{{form.motherOccupation}}</span>
                            </p>
                            <p class='flex2'>
                                <span class="name">工作单位：</span>
                                <span class="detail">{{form.motherEmployer}}</span>
                            </p>
                        </div>
                        <div class="line_flex">
                            <p class='flex2'>
                                <span class="name">父亲职业：</span>
                                <span class="detail">{{form.dadOccupation}}</span>
                            </p>
                            <p class='flex2'>
                                <span class="name">工作单位：</span>
                                <span class="detail">{{form.dadEmployer}}</span>
                            </p>
                        </div>
                        <div class="line_flex">
                            <p class='flex2'>
                                <span class="name">家庭类型：</span>
                                <span class="detail">{{form.familyType}}</span>
                            </p>
                            <p class='flex2'>
                                <span class="name">是否独生：</span>
                                <span class="detail">{{form.isOnlyChild}}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="main_box">
                    <Title title="学生个人情况"></Title>
                    <div class="main">
                        <el-row class="line_flex">
                            <el-col :span="5">孩子的兴趣爱好：</el-col>
                            <el-col :span="20">{{form.studentHobby}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="5">孩子的优点：</el-col>
                            <el-col :span="20">{{form.studentAdvantage}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="5">孩子的缺点：</el-col>
                            <el-col :span="20">{{form.studentdisadvantage}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="5">孩子最好的朋友：</el-col>
                            <el-col :span="20">{{form.studentBestFirend}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="5">孩子喜欢的书：</el-col>
                            <el-col :span="20">{{form.studentLikeBook}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="5">孩子喜欢的电影：</el-col>
                            <el-col :span="20">{{form.studentLikeMovie}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="5">孩子喜欢的明星：</el-col>
                            <el-col :span="20">{{form.studentLikeStar}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="5">孩子向往的职业：</el-col>
                            <el-col :span="20">{{form.studentLookOccupation}}</el-col>
                        </el-row>


                        <el-row class="line_flex">
                            <el-col :span="5">孩子向往的专业：</el-col>
                            <el-col :span="20">{{form.studentLookMajor}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="5">孩子向往的大学：</el-col>
                            <el-col :span="20">{{form.studentlookUniversity}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="5">孩子的身体素质：</el-col>
                            <el-col :span="20">{{form.studentPhysicalQuality}}</el-col>
                        </el-row>
                    </div>
                </div>

                <div class="main_box">
                    <Title title="学生学习情况"></Title>
                    <div class="main">
                        <table class="learning">
                            <thead>
                                <tr>
                                    <th>主管孩子学习</th>
                                    <th>陪同完成作业</th>
                                    <th>辅导孩子作业</th>
                                    <th>检查孩子作业</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{form.learnManageStudent}}</td>
                                    <td>{{form.learnAccompany}}</td>
                                    <td>{{form.learnTutoring}}</td>
                                    <td>{{form.learnCheckHomework}}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table class="learning">
                            <thead>
                            <tr>
                                <th width="254">不懂题目当天解决</th>
                                <th>孩子考试情况</th>
                                <th>孩子学习成绩</th>
                                <th>孩子反映课堂</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>{{form.learnProblem}}</td>
                                <td>{{form.learnExamSituation}}</td>
                                <td>{{form.learnGrades}}</td>
                                <td>{{form.learnFeedbackClass}}</td>
                            </tr>
                            </tbody>
                        </table>


                        <el-row class="line_flex">
                            <el-col :span="7">孩子参加的课外班学科：</el-col>
                            <el-col :span="17">{{form.learnIsJoinCarm=='是'?form.learnIsJoinCarmSubject:'未参加'}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="7">孩子参加的兴趣培养活动：</el-col>
                            <el-col :span="17">{{form.learnIsJoinHobby=='是'?form.learnIsJoinHobbyClass:'未参加'}}</el-col>
                        </el-row>

                        <el-row class="line_flex">
                            <el-col :span="7">孩子学习上的优势：</el-col>
                            <el-col :span="17">{{form.learnAdvantage||'无'}}</el-col>
                        </el-row>
                        <el-row class="line_flex">
                            <el-col :span="7">影响孩子学习的因素：</el-col>
                            <el-col :span="17" v-if="form.learnInfluenceFactorList.length">
                                <span v-for="(value,index) in form.learnInfluenceFactorList" :key="index">{{index!=0?'、':''}}{{value}}</span>
                            </el-col>
                            <el-col :span="17" v-else>
                                <span>无</span>
                            </el-col>
                        </el-row>
                    </div>


                </div>

                <div class="main_box">
                    <Title title="日常生活部分"></Title>
                    <div class="main">
                        <div class="line_box">
                            <p class="title">最近和孩子一起开展的亲子活动/一起看的书或电影：</p>
                            <p class="detail">{{form.lifeActivity}}</p>
                        </div>
                        <div class="line_box">
                            <p class="title">孩子近期做过的最让您或您的家人感动的事：</p>
                            <p class="detail">{{form.lifeMoved}}</p>
                        </div>
                        <div class="line_box">
                            <p class="title">您与孩子之间是否存在交流沟通方面的问题？</p>
                            <p class="detail">{{form.lifeExchange}}</p>
                        </div>
                        <div class="line_box">
                            <p class="title">孩子成长（学习&生活）过程中最让您担心的是：</p>
                            <p class="detail">{{form.lifeWorry}}</p>
                        </div>
                    </div>
                </div>




                <div class="main_box">
                    <Title title="未来规划部分"></Title>
                    <div class="main">
                        <div class="line_box">
                            <p class="title">关于孩子的高考升学，您的规划如下</p>
                        </div>
                        <el-row class="line_flex" >
                            <el-col :span="5">理想专业（方向）：</el-col>
                            <el-col :span="19">{{form.futureMajor}}</el-col>
                        </el-row>
                        <el-row class="line_flex" >
                            <el-col :span="5">理想大学（城市）：</el-col>
                            <el-col :span="19">{{form.futureUniversity}}</el-col>
                        </el-row>
                        <el-row class="line_flex" >
                            <el-col :span="5">高考路径（升学）：</el-col>
                            <el-col :span="19">{{form.futureEducation}}</el-col>
                        </el-row>
                        <div class="line_box">
                            <p class="title">就此规划，您与孩子是否达成一致？若否，请说明矛盾冲突点：</p>
                            <p class="detail">{{form.futureConflict}}</p>
                        </div>
                    </div>
                </div>


                <div class="main_box">
                    <Title title="学业规划期待"></Title>
                    <div class="main">
                        <div class="line_box">
                            <p class="title">您期待在经历系统的学业规划服务后，学生在哪些方面会有提升？</p>
                            <p class="detail">{{form.studyGradesUp}}</p>
                        </div>
                    </div>
                </div>

                <div class="main_box">
                    <Title title="其他部分"></Title>
                    <div class="main">
                        <div class="line_box">
                            <p class="title">您希望孩子在学习之外哪些方面得到提升：</p>
                            <p class="detail" v-if="form.otherSupplement.length"><span v-for="(item,index) in form.otherSupplement">{{index!=0?'、':''}}{{item}}</span></p>
                            <p class="detail" v-else><span>无</span></p>
                        </div>

                        <div class="line_box">
                            <p class="title">您认为在指导孩子的过程中，您需要补充哪些方面的内容：</p>
                            <p class="detail" v-if="form.otherPromote.length"><span v-for="(item,index) in form.otherPromote">{{index!=0?'、':''}}{{item}}</span></p>
                            <p class="detail" v-else><span>无</span></p>
                        </div>
                        <div class="line_box">
                            <p class="title">您期待在经历系统的学业规划服务后，学生在哪些方面会有提升：</p>
                            <p class="detail" >{{form.otherAspect}}</p>
                        </div>
                    </div>
                </div>
            </div>           
        </div>
    </div>
</template>
<script>
import NoContent from "@/components/NoContent.vue";
import Title from '@/components/consultant/MessageTitle.vue'
export default {
    name: "parentMessage.vue",
    props: {
        form: {
            type: Object,
            // 对象或数组默认值必须从一个工厂函数获取
            default: function () {
                return {
                    motherOccupation: '',
                    motherEmployer: '',
                    dadOccupation: '',
                    dadEmployer: '',
                    familyTypeRadio: '',
                    familyType: '',
                    isOnlyChildRadio: '',
                    isOnlyChild: '',
                    // 学生个人情况
                    studentHobby: '', //兴趣爱好
                    studentAdvantage: '', //优点
                    studentdisadvantage: '', //缺点
                    studentBestFirend: '', //最好的朋友
                    studentLikeBook: '', //喜欢的书
                    studentLikeMovie: '', //喜欢的电影
                    studentLikeStar: '', //喜欢的明星
                    studentLookOccupation: '', //向往的职业
                    studentLookMajor: '', //向往的专业
                    studentlookUniversity: '', //向往的大学
                    studentPhysicalQuality: '', //身体素质

                    // 学生学习情况 learn
                    learnManageStudent: '',//主管孩子学习
                    learnAccompany: '',//陪同完成作业
                    learnTutoring: '',//辅导孩子作业
                    learnCheckHomework: '',//检查孩子作业
                    learnPreview: '',//孩子预习情况
                    learnClassEffect: '',//孩子课堂效果
                    learnClassNotes: '',//孩子课堂笔记
                    learnReview: '',//孩子复习情况
                    learnProblem: '',//孩子每天的作业练习，遇到不懂的题目，你是当天一定要想办法解决掉，还是以后再说？
                    learnExamSituation: '',//孩子考试情况
                    learnGrades: '',//孩子学习成绩
                    learnFeedbackClass: '',//孩子反映课堂
                    learnIsJoinCarm: '',//孩子是否参加课外班,是，否
                    learnIsJoinCarmSubject: '',//参加课外班学科
                    learnIsJoinHobby: '',//是否参加兴趣培训服务
                    learnIsJoinHobbyClass: '',//兴趣班培训服务，是，否
                    learnAdvantage: '',//孩子学习上的优势
                    learnInfluenceFactorList: [],// 影响孩子学习的因素（可多选）

                    // 日常生活部分
                    lifeActivity: '',//最近和孩子一起开展的亲子活动/一起看的书或电影：
                    lifeMoved: '',//孩子近期做过的最让您或您的家人感动的事
                    lifeExchange: '',//您与孩子之间是否存在交流沟通方面的问题？（若有，请简要描述；若无，请填写“无”））
                    lifeWorry: '',//孩子成长（学习&生活）过程中最让您担心的是：
                    // 未来规划部分
                    futureMajor: '',//理想专业（方向）
                    futureUniversity: '',//理想大学（城市）
                    futureEducation: '',//高考路径（升学）
                    futureConflict: '',//就此规划，您与孩子是否达成一致？若否，请说明矛盾冲突点：
                    // 学业规划期待
                    studyGradesUp: '',//您期待在经历系统的学业规划服务后，学生在哪些方面会有提升？
                    // 其他部分
                    otherPromote: [],//您希望孩子在学习之外哪些方面得到提升？（可多选）
                    otherSupplement: '',//您认为在指导孩子的过程中，您需要补充哪些方面的内容？（可多选）
                    otherAspect: '',//您觉得我们需要了解孩子的特殊情况？
                }
            }
        },
        isData:{}
    },
    components: {
        Title,
        NoContent
    },
    data() {
        return {
            // form: {
            //     "motherOccupation": "母亲职业",
            //     "motherEmployer": "母亲工作单位",
            //     "dadOccupation": "父亲职业",
            //     "dadEmployer": "父亲工作单位",
            //     "familyTypeRadio": "其他",
            //     "familyType": "其他家庭类型",
            //     "isOnlyChildRadio": "不是",
            //     "isOnlyChild": "不是独生",
            //     "studentHobby": "孩子的兴趣爱好",
            //     "studentAdvantage": "孩子的优点",
            //     "studentdisadvantage": "孩子的缺点",
            //     "studentBestFirend": "子最好的朋友",
            //     "studentLikeBook": "孩子喜欢的书",
            //     "studentLikeMovie": "孩子喜欢的电影",
            //     "studentLikeStar": "孩子喜欢的明星",
            //     "studentLookOccupation": "孩子向往的职业",
            //     "studentLookMajor": "孩子向往的专业",
            //     "studentlookUniversity": "孩子向往的大学",
            //     "studentPhysicalQuality": "孩子的身体素质",
            //     "learnManageStudent": "父亲",
            //     "learnAccompany": "会",
            //     "learnTutoring": "会",
            //     "learnCheckHomework": "会",
            //     "learnPreview": "不预习",
            //     "learnClassEffect": "会",
            //     "learnClassNotes": "不做笔记",
            //     "learnReview": "不复习",
            //     "learnProblem": "从不",
            //     "learnExamSituation": "总紧张",
            //     "learnGrades": "波动大",
            //     "learnFeedbackClass": "听不懂",
            //     "learnIsJoinCarm": "是",
            //     "learnIsJoinCarmSubject": "参与学科数学",
            //     "learnIsJoinHobby": "是",
            //     "learnIsJoinHobbyClass": "兴趣班或特长，跳绳",
            //     "learnAdvantage": "孩子学习上的优势",
            //     "learnInfluenceFactorList": ["学习投入（专注与精力）", "压力应对", "学习效能感", "学习策略（组织与记忆）", "考试应考（技巧与心理）", "成就动机"],
            //     "lifeActivity": "最近和孩子一起开展的亲子活动\/一起看的书或电影：",
            //     "lifeMoved": "孩子近期做过的最让您或您的家人感动的事：",
            //     "lifeExchange": "您与孩子之间是否存在交流沟通方面的问题？（若有，请简要描述；若无，请填写“无”",
            //     "lifeWorry": "孩子成长（学习&生活）过程中最让您担心的是：",
            //     "futureMajor": "理想专业（方向）",
            //     "futureUniversity": "理想大学（城市）",
            //     "futureEducation": "高考路径（升学）",
            //     "futureConflict": "就此规划，您与孩子是否达成一致？若否，请说明矛盾冲突点",
            //     "studyGradesUp": "您期待在经历系统的学业规划服务后，学生在哪些方面会有提",
            //     "otherPromote": ["沟通交际能力", "公益活动", "自我认识及兴趣探索方向", "其他"],
            //     "otherSupplement": ["高考改革政策解读", "中学生综合素质培养", "职业行业介绍", "生涯规划理论及操作"],
            //     "otherAspect": "您觉得我们需要了解孩子的特殊情况，请说明："
            // }
        }
    },
    methods: {

    },
    mounted(){
        // console.log(this.isData,'11111')
    }

}
</script>
<style scoped lang="less">

.parentMessage {
    box-sizing: border-box;
    padding: 20px;
    background-color: #fff;
    header {
        height: 153px;
        background: url("~@img/xueyezixun/studentAndParent/header_ques.png") no-repeat center center;
        line-height: 153px;
        color:#0095EB;
        font-size: 40px;
        text-align: center;
        margin-bottom: 30px;
    }

    .main_box {
        padding-bottom: 40px;
        .main {
            font-size: 18px;
            padding-top: 30px;
            table {
                width: 100%;
                text-align: center;
                line-height: 48px;
                margin-bottom: 40px;
                tr {
                    th {
                        background: rgba(61, 144, 246, 0.2);
                        border: 1px solid rgba(61, 144, 246, 0.2);
                        text-align: center;
                    }
                    td {
                        border: 1px solid rgba(61, 144, 246, 0.2);
                    }
                }
            }
            .learning {
                width: 100%;
            }
        }
    }
    .line_flex {
        display: flex;
        margin-bottom: 20px;
        font-size: 18px;
        .line_flex_title {
            font-size: 20px;
            line-height: 40px;
        }
        .flex3 {
            line-height: 30px;
            width: 33%;
        }
        .flex1 {
            width: 100%;
        }
        .flex2 {
            width: 50%;
        }
    }
    .line_input {
        .name {
            width: 160px;
        }
        .detail {
            flex: 1;
        }
    }
    .line_box{
        padding-bottom: 20px;
        color: #333;
        .title {
            font-size: 18px;
            line-height: 40px;
        }
        .detail {
            font-size: 16px;
            line-height: 30px;
        }
    }

}
.noContent{
    background: #fff;
    min-height: 600px;
}
</style>